import { itemClicked } from '../../../app/browser/analyticsHelpers';
import { defaultPageProps } from '../../../app/browser/analyticsDefaultProperties';

export default {
  identify: {},
  page: {
    name: 'SP : PerformanceFAQ',
    properties: {
      ...defaultPageProps,
      userType: 'Authenticated',
    },
  },
  elements: {
    'performance-faq--*': itemClicked('SP : PerformanceFAQ', 'Link'),
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/browser/FAQAnalytics.js